window.getParameterByName = function (name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

/**
 * Hide input validation errors
 */
window.removeInputValidationErrors = function (parent_el) {
    // remove existing error
    parent_el.find('.validation-errors').remove();
};

window.transliterate2dv = function (input) {
    let _vowels = {
        "ަ": "a",
        "ާ": "aa",
        "ި": "i",
        "ީ": "ee",
        "ު": "u",
        "ޫ": "oo",
        "ެ": "e",
        "ޭ": "ey",
        "ޮ": "o",
        "ޯ": "oa",
        "ް": ""
    };

    let _compounds = {};

    let _alif_compounds = {
        "އަ": "a",
        "އާ": "aa",
        "އި": "i",
        "އީ": "ee",
        "އު": "u",
        "އޫ": "oo",
        "އެ": "e",
        "އޭ": "ey",
        "އޮ": "o",
        "އޯ": "oa"
    };

    let _consonants = {
        "ހ": "h",
        "ށ": "sh",
        "ނ": "n",
        "ރ": "r",
        "ބ": "b",
        "ޅ": "lh",
        "ކ": "k",
        "އ": "a",
        "ވ": "v",
        "މ": "m",
        "ފ": "f",
        "ދ": "dh",
        "ތ": "th",
        "ލ": "l",
        "ގ": "g",
        "ޏ": "y",
        "ސ": "s",
        "ޑ": "d",
        "ޒ": "z",
        "ޓ": "t",
        "ޔ": "y",
        "ޕ": "p",
        "ޖ": "j",
        "ޗ": "ch",
        "ޙ‎": "h",
        "ޚ‎": "kh",
        "ޛ‎": "z",
        "ޜ‎": "z",
        "ޝ‎": "sh",
        "ޝ": "sh"
    };

    let _punctuations = {
        "]": "[",
        "[": "]",
        "\\": "\\",
        "\'": "\'",
        "،": ",",
        ".": ".",
        "/": "/",
        "÷": "",
        "}": "{",
        "{": "}",
        "|": "|",
        ":": ":",
        "\"": "\"",
        ">": "<",
        "<": ">",
        "؟": "?",
        ")": ")",
        "(": "("
    };

    function transliterate(input) {
        // replace zero width non joiners
        input = input.replace(/[\u200B-\u200D\uFEFF]/g, '');


        let v = '';

        // replace words ending in shaviyani with 'ah'
        input = input.replace((/(އަށް)\B/ig), 'ah');
        input = input.replace((/(ށް)\B/ig), 'h');

        // replace thaa sukun with 'i'
        input = input.replace((/(ތް)\B/ig), 'i');

        // replace words ending in alif sukun with 'eh'
        input = input.replace((/(އެއް)\B/ig), 'eh');
        input = input.replace((/(ެއް)\B/ig), 'eh');
        input = input.replace((/(ިއް)\B/ig), 'ih');


        // replace alif compounds first so they don't get in the way
        for (var k in _alif_compounds) {
            if (!_alif_compounds.hasOwnProperty(k)) continue;
            v = _alif_compounds[k];
            input = input.replace(new RegExp(k, 'ig'), v);
        }

        // replace words ending in alif sukun with 'ah'
        input = input.replace((/(ައް)\B/ig), 'ah');

        // replace words ending ai bai fili
        input = input.replace((/(ައި)\B/ig), 'ai');

        // remaining consonants
        for (var k in _consonants) {
            if (!_consonants.hasOwnProperty(k)) continue;

            v = _consonants[k];
            input = input.replace(new RegExp(k, 'g'), v);
        }

        // vowels
        for (var k in _vowels) {
            if (!_vowels.hasOwnProperty(k)) continue;

            v = _vowels[k];

            input = input.replace(new RegExp(k, 'g'), v);
        }

        // capitalize first letter of sentence
        input = input.replace(/(^\s*\w|[\.\!\?]\s*\w)/g, function (c) {
            return c.toUpperCase();
        });

        for (var k in _punctuations) {
            if (!_punctuations.hasOwnProperty(k)) continue;
            p = _punctuations[k];
            input = input.replace(k, p);
        }

        return input;
    }

    // _____ construct
    return transliterate(input);
};

/**
 * Restrict input characters
 * http://www.qodo.co.uk/blog/javascript-restrict-keyboard-character-input/
 */
window.restrictCharacters = function (myfield, e, restrictionType) {
    if (!e) var e = window.event;
    if (e.keyCode) code = e.keyCode;
    else if (e.which) code = e.which;
    var character = String.fromCharCode(code);
    // if they pressed esc... remove focus from field...
    if (code == 27) {
        this.blur();
        return false;
    }
    // ignore if they are press other keys
    // strange because code: 39 is the down key AND ' key...
    // and DEL also equals .
    if (!e.ctrlKey && code != 9 && code != 8 && code != 36 && code != 37 && code != 38 && (code != 39 || (code == 39 && character == "'")) && code != 40) {
        if (character.match(restrictionType)) {
            return true;
        } else {
            return false;
        }
    }
};

/**
 * checks if a given coordinate is in the correct format
 */
window.check_lat_lng = function (lat, lon) {
    ck_lat = /^(-?[1-8]?\d(?:\.\d{1,18})?|90(?:\.0{1,18})?)$/;
    ck_lon = /^(-?(?:1[0-7]|[1-9])?\d(?:\.\d{1,18})?|180(?:\.0{1,18})?)$/;
    var validLat = ck_lat.test(lat);
    var validLon = ck_lon.test(lon);
    if (validLat && validLon) {
        return true;
    } else {
        return false;
    }
};

/**
 * Convert url to slug
 */
window.slugify = function (str, special_char) {
    if (typeof (special_char) === 'undefined') special_char = '-';
    str = transliterate2dv(str);
    str = str.toLowerCase();
    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, special_char) // collapse whitespace and replace by -
        .replace(/-+/g, special_char); // collapse .

    return str;
};

/**
 * Remove string from beginnig
 */
window.removeFromHead = function (needle, haystack) {
    needle = needle.toLowerCase();
    var ls_haystack = haystack.toLowerCase();
    while (needle.length > 0) {
        if (ls_haystack.indexOf(needle) == 0) {
            return haystack.substring(needle.length);
        } else {
            needle = needle.slice(0, -1);
        }
    }
    return haystack;
};

/**
 * Generate a random string
 *
 * @return string
 */
window.randString = function (len) {
    var string = '';
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (var i = 0; i < len; i++) {
        string += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return string;
};

/**
 * Show loading
 */
window.toggleLoading = function (elem, show) {
    if (elem.hasClass('zmdi')) {
        if (show) {
            elem.addClass('loading');
        } else {
            elem.removeClass('loading');
        }
    } else {
        if (show) {
            var loading = '<i class="zmdi zmdi-spinner zmdi-spin zmdi-pulse loading"> ';
            elem.children('i').hide();
            elem.prepend(loading);
        } else {
            elem.children('.loading').remove();
            elem.children('i').show();
        }
    }

    togglePreloader(show);
};

/**
 * Toggle preloader
 */
window.togglePreloader = function (show) {
    if (show) {
        $('.page-loader').show();
    } else {
        $('.page-loader').hide();
    }
};

$(document).ready(function () {

    if ($('[data-toggle="tooltip"]')[0]) {
        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'click',
            delay: {show: 200, hide: 100}
        });
    }

    //post
    $('[data-post-url]').click(function (e) {
        e.preventDefault();
        var request_url = $(this).data('post-url');
        var redirect_url = $(this).data('redirect-url');
        var params = $(this).data('params') || {};
        var method = $(this).data('method') || 'POST';
        var is_delete = $(this).data('delete') || false;
        var confirmation_message = $(this).data('confirmation') || '';
        var success_message = $(this).data('success') || '';
        var _this = this;

        if (request_url) {

            // process the params
            var request_params = {};
            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    var val = params[key];

                    if (key.startsWith(':')) {
                        key = key.substring(1);
                        val = $(val).val();
                    }

                    request_params[key] = val;
                }
            }

            function do_request() {
                $.ajax({
                    url: request_url,
                    type: method,
                    data: request_params,
                    beforeSend: function () {
                        toggleLoading($(_this), true);
                    },
                    complete: function () {
                        toggleLoading($(_this), false);
                    },
                    success: function (result) {
                        if (success_message) {
                            Swal.fire({
                                title: 'Success!',
                                text: success_message,
                                icon: 'success'
                            }).then(
                                function () {
                                    redirectPage(redirect_url);
                                }
                            );
                        } else {
                            redirectPage(redirect_url);
                        }
                    },
                    error: function (xhr) {
                        if (xhr.status == 422) {
                            showValidationErrorMsg(xhr);
                        } else {
                            Swal.fire({
                                title: 'Error!',
                                text: 'An error occurred while performing the action.',
                                icon: 'error'
                            });
                        }
                    }
                });
            }

            // get delete confirmation
            if (is_delete || confirmation_message) {
                Swal.fire({
                    title: 'Are you sure?',
                    text: is_delete ? 'You will not be able to undo this delete operation!' : confirmation_message,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: is_delete ? 'Yes, delete it!' : 'Yes',
                }).then(function (result) {
                    if (result.value) {
                        do_request();
                    }
                });
            } else {
                do_request();
            }
        }
    });

    //delete
    $('.delete-link').click(function (e) {
        e.preventDefault();
        var request_url = $(this).data('request-url');
        var redirect_url = $(this).data('redirect-url');
        var _this = this;
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to undo this delete operation!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
        }).then(function (result) {
            if (result.value) {
                $.ajax({
                    url: request_url,
                    type: 'DELETE',
                    beforeSend: function () {
                        toggleLoading($(_this), true);
                    },
                    complete: function () {
                        toggleLoading($(_this), false);
                    },
                    success: function (result) {
                        Swal.fire({
                            title: 'Deleted!',
                            text: 'The record has been deleted.',
                            icon: 'success'
                        }).then(
                            function () {
                                redirectPage(redirect_url);
                            }
                        );
                    },
                    error: function () {
                        Swal.fire({
                            title: 'Error!',
                            text: 'An error occurred while deleting.',
                            icon: 'error'
                        });
                    }
                });
            }
        });
    });

    //url input
    $("input[type='url']").keyup(function (e) {
        string = $(this).val();
        if (!(/^(http|https):\/\//i.test(string))) {
            var protocol = 'http';
            var removed = removeFromHead("http", string);
            if (removed.indexOf('s') == 0) {
                removed = removeFromHead("s://", removed);
                protocol += 's';
            } else {
                removed = removeFromHead("://", removed);
            }
            if (removed != '') {
                string = protocol + "://" + removed;
            }
        }
        $(this).val(string);
    });

    // check all boxes when select all clicked
    $('input[type="checkbox"][data-all]').on('change', function (e) {
        e.preventDefault();
        var select_all_name = $(this).data('all');
        var is_checked = $(this).prop('checked');
        $('input[type="checkbox"][data-check="' + select_all_name + '"]').each(function () {
            $(this).prop('checked', is_checked);
        });
    });

    // uncheck select all when one box unchecked
    $('input[type="checkbox"][data-check]').on('change', function (e) {
        e.preventDefault();
        var is_checked = $(this).prop('checked');
        if (!is_checked) {
            var select_all_name = $(this).data('check');
            var select_all = $('input[type="checkbox"][data-all="' + select_all_name + '"]');
            if (select_all) {
                select_all.prop('checked', false);
            }
        }
    });

    //checkbox disable toggle
    $('[data-toggle-checkbox]').change(function () {
        var input = $($(this).data('toggle-checkbox'));
        if (input.length) {
            var checked = $(this).is(':checked');
            input.each(function () {
                $(this).prop('disabled', checked);
            });
        }
    }).trigger('change');

    // disable on select
    $('[data-disable-on-select]').on('change', function () {
        var fields = $($(this).data('disable-on-select'));
        if (fields.length) {
            var disable = $(this).val() && true;
            var hide_fields = $(this).data('hide-fields') || false;

            if (disable) {
                // if disable, select only enabled
                fields.find('select:enabled, input:enabled').each(function () {
                    $(this).prop('disabled', true)
                        .addClass('auto-disabled');
                });
            } else {
                // if enable, select only auto-disabled
                fields.find('select.auto-disabled:disabled, input.auto-disabled:disabled').each(function () {
                    $(this).prop('disabled', false)
                        .removeClass('auto-disabled');
                });
            }

            if (hide_fields) {
                if (disable) {
                    fields.slideUp();
                } else {
                    fields.slideDown();
                }
            }
        }
    }).trigger('change');

    //checkbox enable toggle
    $('[data-enable-checkbox]').change(function () {
        var fields = $($(this).data('enable-checkbox'));
        var checked = $(this).is(':checked');
        var enable = $(this).data('disable') ? !checked : checked;
        if (fields.length) {
            if (enable) {
                // if enable, select only auto-disabled
                fields.find('select.auto-disabled:disabled, input.auto-disabled:disabled').each(function () {
                    $(this).prop('disabled', false)
                        .removeClass('auto-disabled');
                });

                fields.slideDown();
            } else {
                // if disable, select only enabled
                fields.find('select:enabled, input:enabled').each(function () {
                    $(this).prop('disabled', true)
                        .addClass('auto-disabled');
                });

                fields.slideUp();
            }
        }
    }).trigger('change');

    // redirect on select
    $('[data-select-redirect]').on('change', function () {
        var param = $(this).prop('name');
        var url = $(this).data('select-redirect');
        var selected_val = $(this).val();

        if (selected_val) {
            var url_obj = new URL(url);
            var search_params = url_obj.searchParams;

            search_params.set(param, selected_val);

            url_obj.search = search_params.toString();

            var new_url = url_obj.toString();

            redirectPage(new_url);
        }
    });

    //delete form
    $('.delete-form').submit(function (e) {
        var action_control = $(this).find('[name=action]');
        var action = action_control ? action_control.val() : '';

        if (action == 'delete' || action == 'force_delete') {
            e.preventDefault();
            Swal.fire({
                title: 'Are you sure?',
                text: 'You will not be able to undo this delete operation!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
            }).then(function (result) {
                if (result.value) {
                    e.currentTarget.submit();
                }
            });
        }
    });

    //status
    $('.status-link').click(function (e) {
        e.preventDefault();
        var request_url = $(this).data('request-url');
        var redirect_url = $(this).data('redirect-url');
        var new_status = $(this).data('new-status');
        var _this = this;
        if (request_url) {
            $.ajax({
                url: request_url,
                type: 'PUT',
                data: {enable: new_status},
                beforeSend: function () {
                    toggleLoading($(_this), true);
                },
                complete: function () {
                    toggleLoading($(_this), false);
                },
                success: function (result) {
                    Swal.fire({
                        title: 'Updated!',
                        text: 'The record status has been updated.',
                        icon: 'success'
                    }).then(
                        function () {
                            redirectPage(redirect_url);
                        }
                    );
                },
                error: function () {
                    Swal.fire({
                        title: 'Error!',
                        text: 'An error occurred while updating the status.',
                        icon: 'error'
                    });
                }
            });
        }
    });

    //allow TAB inside code textarea
    $(document).delegate('textarea.code-text', 'keydown', function (e) {
        var keyCode = e.keyCode || e.which;

        if (keyCode == 9) {

            e.preventDefault();
            var start = $(this).get(0).selectionStart;
            var end = $(this).get(0).selectionEnd;

            // set textarea value to: text before caret + tab + text after caret
            $(this).val($(this).val().substring(0, start)
                + "\t"
                + $(this).val().substring(end));

            // put caret at right position again
            $(this).get(0).selectionStart =
                $(this).get(0).selectionEnd = start + 1;
        }
    });

    //js delete
    $('[data-deletable]').on('click', '[data-delete]', function (e) {
        e.preventDefault();
        $(this).closest($(this).data('delete')).remove();

        /*if ( $(this).hasClass('sortable') ) {
            $(this).sortable('refresh');
        }*/
    });

    //sortable
    $('.sortable').sortable({
        placeholder: 'ui-state-highlight',
        helper: 'clone',
        update: function (event, ui) {
            var sort_url = $(this).data('sort-url');
            if (sort_url) {
                var data = $(this).sortable('serialize');

                // POST to server using $.post or $.ajax
                $.ajax({
                    data: data,
                    type: 'PUT',
                    url: sort_url
                });
            }
        }
    });

    //form sort
    $('[data-sort-field]').click(function (e) {
        e.preventDefault();

        //find the parent form
        var parent_form_selector = $(this).closest('[data-form-sortable]').data('form-sortable');
        var parent_form = $('form' + parent_form_selector);
        if (parent_form) {

            var field = $(this).data('sort-field');
            var order = $(this).hasClass('sorting_asc') ? 'DESC' : 'ASC';

            parent_form.find('[name="orderby"]').val(field);
            parent_form.find('[name="order"]').val(order);
            parent_form.submit();
        }
    });

    //toggle fields
    $('[data-tg-toggle]').on('click', function (e) {
        e.preventDefault();
        var toggle_block = $($(this).data('tg-toggle'));
        if (toggle_block.length) {
            toggle_block.toggleClass('toggled');
            var toggle_icon = $(this).data('tg-icon') || 'zmdi-edit';
            $(this).toggleClass(toggle_icon + ' zmdi-close');
        }
    });

    //input toggle
    $('[data-input-toggle]').on('click', function (e) {
        e.preventDefault();
        var input = $($(this).data('input-toggle'));
        if (input.length) {
            input.prop('disabled', !input.prop('disabled'));
            var toggle_icon = $(this).data('tg-icon') || 'zmdi-edit';
            $(this).find('i').toggleClass(toggle_icon + ' zmdi-close');
        }
    });

    /**
     * Edit the selected model
     */
    $('[data-edit-selected]').each(function (e) {
        var selector = $(this).data('edit-selected');
        var url = $(this).data('edit-selected-url');
        var _this = this;

        $(selector).on('change', function () {
            var selected = $(this).val();

            if (selected) {
                var href = url.replace(/:id/g, selected);

                $(_this)
                    .removeClass('disabled')
                    .prop('href', href);
            } else {
                $(_this)
                    .addClass('disabled')
                    .prop('href', '#');
            }
        });
    });

    // clear date
    $('[data-date-clear]').on('click', function (e) {
        e.preventDefault();

        var date_el = $($(this).data('date-clear'));

        if (date_el.length && (!date_el.prop('disabled'))) {
            date_el.val('').trigger('change');
        }
    });

    // set the min date based on another element
    $('.datetime-range-picker').each(function () {
        var start_el = $(this).find('.start-date');
        var end_el = $(this).find('.end-date');

        var start_picker = start_el.flatpickr({
            allowInput: true,
            enableTime: true,
            nextArrow: '<i class="zmdi zmdi-long-arrow-right" />',
            prevArrow: '<i class="zmdi zmdi-long-arrow-left" />',
            maxDate: end_el.attr('value'),
            onClose: function(selectedDates, dateStr, instance) {
                end_picker.set('minDate', dateStr);
            },
        });

        var end_picker = end_el.flatpickr({
            allowInput: true,
            enableTime: true,
            nextArrow: '<i class="zmdi zmdi-long-arrow-right" />',
            prevArrow: '<i class="zmdi zmdi-long-arrow-left" />',
            minDate: start_el.attr('value'),
            onClose: function(selectedDates, dateStr, instance) {
                startpicker.set('maxDate', dateStr);
            },
        });

        start_el.on('change', function () {
            end_picker.set('minDate', $(this).val());
        });

        end_el.on('change', function () {
            start_picker.set('maxDate', $(this).val());
        });
    });

    /**
     * Slug
     */
    $('.slug.input-group').each(function (e) {

        var _this = $(this);
        var input = _this.find('input');
        var toggled = _this.data('toggled') || false;
        var toggle_icon = _this.data('tg-icon') || 'zmdi-edit';
        var save_icon = 'zmdi-check';
        var cancel_btn = _this.find('.cancel');
        var edit_btn = _this.find('.edit');
        var link = _this.find('.url');
        var url_prefix = _this.find('.url-prefix');
        var prefix = url_prefix.text().trim();

        // save the value
        _this.data('val', input.val());

        // Hide inputs
        function hideInput() {
            // change the input type to hidden
            input.prop('type', 'hidden');

            // change icon to edit
            edit_btn.find('i')
                .removeClass(save_icon)
                .addClass(toggle_icon);

            // hide the cancel button
            cancel_btn.addClass('d-none');

            // hide the url prefix
            url_prefix.addClass('d-none');

            // change the link
            link.text(prefix + input.val())
                .removeClass('d-none');

            _this.removeClass('toggled');

            toggled = false;
        }

        // Save inputs
        function saveInput(val) {
            // save the current value
            input.val(slugify(val));
            _this.data('val', val);

            // enable the input
            input.prop('disabled', false);
        }

        _this.on('slug.change', function (e, val) {
            if (!toggled) {
                saveInput(val);
                hideInput();
            }
        });

        //slug toggle
        edit_btn.on('click', function (e) {
            e.preventDefault();

            saveInput(input.val());

            // saving
            if (toggled) {
                hideInput();
                _this.trigger('slug.saved');
            } else {
                // editing

                // change the input type to text
                input.prop('type', 'text');

                // hide the link
                link.addClass('d-none');

                // show the url prefix
                url_prefix.removeClass('d-none');

                // change icon to save
                $(this).find('i')
                    .removeClass(toggle_icon)
                    .addClass(save_icon);

                // show the cancel button
                cancel_btn.removeClass('d-none');

                _this.addClass('toggled');

                toggled = true;
            }
        });

        // cancel slug update
        cancel_btn.on('click', function (e) {
            e.preventDefault();

            // reset the value
            input.val(_this.data('val'));

            // disable the input
            //input.prop('disabled', true);

            // hide the input
            hideInput();
        });
    });

    // confirm button
    $('[data-confirm]').on('click', function (e) {
        e.preventDefault();

        var target_form = $(this).closest('form');
        var _this = $(this);

        if (target_form.length) {
            Swal.fire({
                title: 'Are you sure?',
                text: _this.data('confirm') || 'Just checking if you wanted to really do this.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, continue!',
            }).then(function (result) {
                if (result.value) {
                    $('<input>', {
                        type: 'hidden',
                        name: _this.attr('name'),
                        value: _this.val()
                    }).appendTo(target_form);

                    target_form.submit();
                }
            });
        }
    });

    $('form.tab-form').on('submit', function (e) {
        togglePreloader(true);
    });

    $('[data-filter-checkboxes]').on('keyup', function () {
        var query = $(this).val().toLowerCase();
        var checkboxes = $(this).data('filter-checkboxes');

        $(checkboxes + ' > .checkbox').each(function () {
            if ($(this).text().toLowerCase().indexOf(query) != -1) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    });

    $('[data-toggle-hide]').on('click', function (e) {
        e.preventDefault();
        var elem = $($(this).data('toggle-hide'));

        if (elem.length) {
            if (elem.data('toggled') || false) {
                elem.hide();
                elem.data('toggled', false);
            } else {
                elem.show();
                elem.data('toggled', true);
            }
        }
    });

    /**
     * Categories Card
     */
    /**
     * Categories Card
     */
    $('.categories-card').each(function (e) {
        var _this = $(this);
        var add_category_btn = _this.find('.add-category');
        var categories_list = _this.find('.categories-list');
        var adding_category = false;

        if (add_category_btn.length) {
            var post_url = add_category_btn.prop('href');
            var name_input = _this.find('input[name="category_name"]');
            var slug_input = _this.find('input[name="category_slug"]');
            var categories_name = categories_list.data('categories-name');

            slug_input.keypress(function (e) {
                return restrictCharacters($(this), e, /[ -A-Za-z0-9]/g);
            });

            name_input.keyup(function () {
                var str = $(this).val();
                slug_input.val(slugify(str, '-'));
            });

            add_category_btn.on('click', function (e) {
                e.preventDefault();
                if (!adding_category) {
                    var name_str = name_input.val();
                    var slug_str = slug_input.val();

                    $.ajax({
                        url: post_url,
                        type: 'POST',
                        data: {
                            name: name_str,
                            slug: slug_str
                        },
                        beforeSend: function () {
                            adding_category = true;
                            add_category_btn.addClass('disabled');
                            toggleLoading(add_category_btn, true);
                        },
                        complete: function () {
                            adding_category = false;
                            add_category_btn.removeClass('disabled');
                            toggleLoading(add_category_btn, false);
                        },
                        success: function (result) {
                            removeInputValidationErrors(_this);
                            var html =
                                '<div class="checkbox">' +
                                '<input id="new-' + categories_name + '-' + result.id + '" name="' + categories_name + '[]" value="' + result.id + '" type="checkbox" checked />' +
                                '<label class="checkbox__label" for="new-' + categories_name + '-' + result.id + '">' +
                                result.name +
                                '</label>' +
                                '</div>';

                            categories_list.prepend(html);
                            name_input.val('');
                            slug_input.val('').trigger('change');
                        },
                        error: function (xhr) {
                            if (xhr.status == 422) {
                                showInputValidationErrors(xhr, _this, 'category_');
                            } else {
                                swal('Error!', 'An error occurred while adding the category.', 'error');
                            }
                        }
                    });

                }
            });
        }
    });

    $('[data-filter-links]').on('keyup', function () {
        var query = $(this).val().toLowerCase();
        var links_ul = $(this).data('filter-links');

        $(links_ul + ' li').each(function () {
            if ($(this).text().toLowerCase().indexOf(query) != -1) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    });

    // append to html
    $('[data-append]').on('click', function (e) {
        e.preventDefault();
        var elem = $($(this).data('append'));
        var html = $(this).data('append-html');
        var id = elem.data('next-id') || 0;

        html = html.replace(/:id/g, id);
        html = html.replace(/:no/g, id + 1);
        elem.append(JSON.parse(html));

        id++;
        elem.data('next-id', id);
    });

    // Enable the section only when another element is a
    // given value
    $('[data-enable-section-value]').each(function () {
        var _this = $(this);
        var value = _this.data('enable-section-value');
        var element = $(_this.data('enable-elem'));
        var hide_fields = _this.data('hide-fields') || false;
        var disable_on_select = _this.data('disable') || false;

        if (element.length) {
            element.on('change', function () {
                var curr_val = $(this).val();
                var matching_selected = false;

                if (value instanceof Array) {
                    matching_selected = value.findIndex(function (e) {
                        return e == curr_val;
                    }) > -1;
                } else {
                    matching_selected = curr_val == value;
                }

                var enable = disable_on_select ? (!matching_selected) : matching_selected;

                if (enable) {
                    // if enable, enable only auto-disabled
                    _this.find('select.auto-disabled:disabled, input.auto-disabled:disabled, textarea.auto-disabled:disabled').each(function () {
                        $(this).prop('disabled', false)
                            .removeClass('auto-disabled');
                    });
                } else {
                    // if disable, enable only enabled
                    _this.find('select:enabled, input:enabled, textarea:enabled').each(function () {
                        $(this).prop('disabled', true)
                            .addClass('auto-disabled');
                    });
                }

                if (hide_fields) {
                    if (enable) {
                        _this.slideDown();
                    } else {
                        _this.slideUp();
                    }
                }
            }).trigger('change');
        }
    });

    // Enable the section only when check box is checked
    $('[data-enable-section-checkbox]').each(function () {
        var _this = $(this);
        var checkbox = $(_this.data('enable-section-checkbox'));
        var hide_fields = _this.data('hide-fields') || false;
        var disable_on_select = _this.data('disable') || false;

        if (checkbox.length) {
            checkbox.on('change', function () {
                var matching_selected = checkbox.is(':checked');
                var enable = disable_on_select ? (!matching_selected) : matching_selected;

                if (enable) {
                    // if enable, enable only auto-disabled
                    _this.find('select.auto-disabled:disabled, input.auto-disabled:disabled, textarea.auto-disabled:disabled').each(function () {
                        $(this).prop('disabled', false)
                            .removeClass('auto-disabled');
                    });
                } else {
                    // if disable, enable only enabled
                    _this.find('select:enabled, input:enabled, textarea:enabled').each(function () {
                        $(this).prop('disabled', true)
                            .addClass('auto-disabled');
                    });
                }

                if (hide_fields) {
                    if (enable) {
                        _this.slideDown();
                    } else {
                        _this.slideUp();
                    }
                }
            }).trigger('change');
        }
    });

    // Pie Chart
    $('[data-flot-pie]').each(function () {
        var _this = $(this);
        var pie = _this.find('.flot-pie');
        var pieData = _this.data('flot-pie');
        var legend_el = _this.find('.flot-chart-legend--pie');
        var numCols = _this.data('num-cols');

        numCols = numCols === undefined ? 1 : numCols;

        pie.plot(pieData, {
            series: {
                pie: {
                    show: true,
                    stroke: {
                        width: 2
                    }
                }
            },
            legend: {
                container: legend_el,
                backgroundOpacity: 0.5,
                noColumns: numCols,
                backgroundColor: "white",
                lineWidth: 0,
                labelBoxBorderColor: '#fff'
            },
            grid: {
                hoverable: true,
            }
        });
    });

    // Tooltips for Flot Charts
    if ($('.flot-chart:not(.flot-pie)')[0]) {
        $('.flot-chart:not(.flot-pie)').bind('plothover', function (event, pos, item) {
            if (item) {
                var x = item.datapoint[0].toFixed(2),
                    y = item.datapoint[1].toFixed(2);
                $('.flot-tooltip.flot-chart-tooltip').html(item.series.label + ' of ' + x + ' = ' + y).css({top: item.pageY+5, left: item.pageX+5}).show();
            }
            else {
                $('.flot-tooltip.flot-chart-tooltip').hide();
            }
        });

        $('<div class="flot-tooltip flot-chart-tooltip"></div>').appendTo('body');
    }
    // Tooltips for Flot Charts
    if ($('.flot-pie')[0]) {
        $('.flot-pie').bind('plothover', function (event, pos, item) {
            if (item) {
                var percent = item.datapoint[0].toFixed(2);
                var count = item.series.data[0][1];

                $('.flot-tooltip.flot-pie-tooltip').html(item.series.label + ' = ' + count + '  (' + percent + '%)').css({top: pos.pageY+5, left: pos.pageX+5}).show();
            }
            else {
                $('.flot-tooltip.flot-pie-tooltip').hide();
            }
        });

        $('<div class="flot-tooltip flot-pie-tooltip"></div>').appendTo('body');
    }


    /**
     * Edit the selected model
     */
    $('.sparkline-bar-stats').each(function (e) {
        $(this).sparkline('html', {
            type: 'bar',
            height: 36,
            barWidth: 3,
            barColor: '#fff',
            barSpacing: 2
        });
    });

    $('.dynamic-resources-table').on('click', '.dynamic-resource .btn-delete', function(e) {
        var uploader = $(this).closest('[data-resources-uploader]');
        var upload_url = uploader.data('resources-uploader');
        var upload_params = uploader.data('params') || {};
        var _this = $(this).closest('.dynamic-resource');

        _this.resourceId = _this.data('resource-data').resource_id;
        _this.errorDisplay = _this.find('.error-msg');
        _this.deleteButton = _this.find('.btn-delete');

        // abort if no resource id
        if (! _this.resourceId) {
            return;
        }

        e.preventDefault();

        // prompt the user
        Swal.fire({
            title: __('Are you sure?'),
            text: __('You will not be able to undo this delete operation!'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: __('Yes, delete it!'),
            cancelButtonText: __('Cancel')
        }).then(function(result){
            if (result.value) {
                // delete the resource
                $.ajax({
                    url: upload_url + '/' + _this.resourceId,
                    data: JSON.stringify(upload_params),
                    contentType: 'application/json',
                    type: 'DELETE',
                    beforeSend: function () {
                        toggleLoading(_this.deleteButton, true);
                    },
                    complete: function () {
                        toggleLoading(_this.deleteButton, false );
                    },
                    success: function (result) {
                        _this.deleteButton.hide();
                        _this.errorDisplay.hide();
                        _this.resourceId = null;

                        _this.remove();
                    },
                    error: function (xhr) {
                        if (xhr.status == 422) {
                            showValidationErrorMsg(xhr);
                        } else {
                            _this.errorDisplay.text(__('Failed to delete the resource'));
                            _this.errorDisplay.show();
                        }
                    }
                });
            }
        });

    });

    $('[data-resource-adder]').each(function () {
        var _this = $(this);
        var upload_details = _this.data('resource-adder');
        var max_upload_size = upload_details.max_upload_size;
        var upload_url = upload_details.upload_url;
        var upload_params = upload_details.params || {};


        var file_input = _this.find('input[type=file]');

        _this.theme = _this.data('theme') || 'admin';
        _this.nameInput = _this.find('input[name="name"]');
        _this.progressDisplay = _this.find('.progress');
        _this.progressBar = _this.find('.progress-bar');
        _this.cancelButton = _this.find('.btn-cancel');
        _this.errorDisplay = _this.find('.error-msg');
        _this.fileSelector = _this.find('.fileinput');
        _this.fileDismiss = _this.find('[data-dismiss="fileinput"]');
        _this.resourcesTbody = $(_this.data('resources-table') + ' tbody');

        if (file_input.length) {

            var mime_types = file_input.prop('accept').split(',');

            // hide the error when file dismissed
            _this.fileDismiss.click(function () {
                _this.errorDisplay.hide();
            });

            file_input.change(function (e) {

                var params = upload_params;

                if (_this.nameInput.val()) {
                    params.name = _this.nameInput.val();
                } else {
                    params.name = '';
                }

                $(this).simpleUpload(upload_url, {

                    allowedTypes: mime_types,
                    maxFileSize: max_upload_size * 1024, // convert kb to bytes
                    data: params,
                    name: 'resource',

                    start: function (file) {
                        //upload started

                        /*
                         * Since "this" differs depending on the function in which it is called,
                         * we need to assign "this" to a local variable to be able to access
                         * this.upload.cancel() inside another function call.
                         */

                        var that = this;

                        _this.cancelButton.click(function (e) {
                            e.preventDefault();
                            that.upload.cancel();
                            //now, the cancel callback will be called
                        });

                        _this.progressDisplay.show();
                        _this.cancelButton.show();
                        _this.nameInput.prop('disabled', true);
                        _this.errorDisplay.hide();
                        _this.fileSelector.hide();
                    },

                    progress: function (progress) {
                        //received progress
                        _this.progressBar.width(progress + "%");
                    },

                    success: function (data) {
                        //upload successful
                        _this.progressDisplay.hide();
                        _this.cancelButton.hide();
                        _this.errorDisplay.hide();
                        _this.fileSelector.show();
                        _this.nameInput.val('');
                        _this.nameInput.prop('disabled', false);
                        _this.fileDismiss.trigger('click');

                        var file_name = $('<div />').text(data.name).html();
                        var file_ext = $('<div />').text(data.extension).html();

                        var html =
                            `<tr class="dynamic-resource">
                                <td data-col="Resource">
                                    <a href="${data.url}" target="_blank">
                                        ${file_name}
                                    </a>
                                </td>

                                <td data-col="File">
                                    <span class="d-inline-block ltr file-details">
                                        <i class="${(_this.theme == 'web' ? 'mr-2 ' + data.web_icon : data.icon)}"></i>
                                        <span> .${file_ext} ${data.human_readable_size}</span>
                                    </span>
                                    <strong class="mt-2 error-msg text-danger" style="display: none;"></strong>
                                </td>

                                <td class="w-md-small">
                                    <a href="#" class="btn-delete btn ${(_this.theme == 'admin' ? 'btn-danger btn--icon-text btn--raised' : 'btn-light-danger')}">
                                        <i class="${(_this.theme == 'web' ? 'far fa-trash bd-mr-2' : 'zmdi zmdi-delete')}"></i> ${__('Delete')}
                                    </a>
                                </td>
                            </tr>`;

                        var row = $(html);
                        row.data('resource-data', {
                            resource_id: data.id
                        });

                        _this.resourcesTbody.append(row);
                    },

                    error: function (error) {
                        //upload failed
                        _this.progressDisplay.hide();
                        _this.cancelButton.hide();

                        var error_msg = __(error.message + '.');

                        if (error.name == 'RequestError') {
                            var status = error.xhr.status;

                            if (status == 413) {
                                error_msg += ' ' + __('File is too big.');
                            } else if (error.xhr.hasOwnProperty('responseJSON')) {
                                error_msg += ' ' + (error.xhr.responseJSON.error || '');
                            }
                        }

                        _this.fileDismiss.trigger('click');
                        _this.errorDisplay.text(error_msg).show();
                        _this.fileSelector.show();
                        _this.nameInput.val('');
                        _this.nameInput.prop('disabled', false);
                    },

                    cancel: function () {
                        //upload cancelled
                        _this.progressDisplay.hide();
                        _this.cancelButton.hide();
                        _this.errorDisplay.hide();
                        _this.fileDismiss.trigger('click');
                        _this.fileSelector.show();
                        _this.nameInput.val('');
                        _this.nameInput.prop('disabled', false);
                    }

                });

            });
        }
    });

    /**
     * File upload input
     */
    $('[data-progress-uploader]').each(function (main_el) {
        var _this = $(this);
        var is_uploading = _this.data('is-uploading') || false;
        var upload_params = _this.data('progress-uploader') || {};
        var file_input = _this.find('input[type=file]');
        var input_name = file_input.attr('name');

        _this.progressDisplay = _this.find('.progress');
        _this.progressText = _this.find('.progress-text');
        _this.progressBar = _this.find('.progress-bar');
        _this.cancelButton = _this.find('.btn-cancel');
        _this.errorDisplay = _this.find('.error-msg');
        _this.fileSelector = _this.find('.fileinput');
        _this.fileDismiss = _this.find('[data-dismiss="fileinput"]');
        _this.filePreview = _this.find('.progress-file-preview');

        file_input.on('change', function (e) {
            // return if already uploading
            if (is_uploading) {
                return;
            }

            var files = e.target.files || e.dataTransfer.files;

            // abort if no files selected
            if (! files.length) {
                return;
            }

            // get the specific file
            var file = files[0];

            _this.errorDisplay.hide();
            _this.progressText.hide();
            _this.progressDisplay.hide();

            // get the file size in kb
            var max_file_size = _this.data('max-file-size') || (2 * 1024); // default to 2MB
            var file_size_kb = Math.round((file.size / 1024));

            // validate file size
            if (file_size_kb > max_file_size) {
                var max_file_size_mb = Math.round(max_file_size / 1024);

                _this.errorDisplay.text('File size cannot be greater than ' + max_file_size_mb + 'MB').show();
                _this.fileDismiss.trigger('click');

                // abort
                return;
            }

            // get the accepted file types
            var accepted_types = this.accept.split(',');
            var num_accepted = accepted_types.length;

            // validate file type
            var accepted = false;
            for (var i = 0; i < num_accepted; i++) {
                var MIMEtype = new RegExp(accepted_types[i].trim().replace('*', '.\*'));
                if (MIMEtype.test(file.type)) {
                    accepted = true;
                    break;
                }
            }

            if (! accepted) {
                var invalid_file_type_error = _this.data('invalid-file-msg') || 'Only ' + this.accept + ' files are allowed.';

                _this.errorDisplay.text(invalid_file_type_error).show();
                _this.fileDismiss.trigger('click');

                return;
            }

            // get the url
            var form = _this.closest('form');
            if (! form.length) {
                return;
            } // abort if form

            var upload_url = form.attr('action');
            var form_method = form.find('input[name="_method"]');
            var upload_method = form.prop('method') || 'POST';

            if (form_method.length) {
                upload_method = form_method.val();
            }

            if (upload_method !== 'POST') {
                upload_params['_method'] = upload_method;
            }

            var file_size_bytes = file_size_kb * 1024;

            $(this).simpleUpload(upload_url, {
                allowedTypes: accepted_types,
                maxFileSize: max_file_size * 1024, // convert kb to bytes
                data: upload_params,
                name: input_name,

                start: function (file) {
                    //upload started

                    /*
                     * Since "this" differs depending on the function in which it is called,
                     * we need to assign "this" to a local variable to be able to access
                     * this.upload.cancel() inside another function call.
                     */

                    var that = this;

                    _this.cancelButton.click(function (e) {
                        e.preventDefault();
                        that.upload.cancel();
                        //now, the cancel callback will be called
                    });

                    _this.filePreview.hide();
                    _this.progressDisplay.show();
                    _this.progressText.show();
                    _this.cancelButton.show();
                    _this.errorDisplay.hide();
                    _this.fileSelector.hide();
                },

                progress: function (progress) {
                    //received progress
                    var bytesUploaded = ((progress / 100.00) * file_size_bytes).toFixed(2);

                    _this.progressText.text('Uploaded ' + humanReadableBytes(bytesUploaded) + ' of ' + humanReadableBytes(file_size_bytes) + ' (' + progress + '%)').show();
                    _this.progressBar.width(progress + "%");
                },

                success: function (data) {
                    _this.cancelButton.hide();

                    Swal.fire({
                        title: __('Success!'),
                        text: __('The file has been uploaded successfully!'),
                        icon: 'success'
                    }).then(function () {
                        redirectPage();
                    });
                },

                error: function (error) {
                    //upload failed
                    _this.progressDisplay.hide();
                    _this.cancelButton.hide();

                    var error_msg = __(error.message + '.');

                    if (error.name == 'RequestError') {
                        var status = error.xhr.status;

                        if (status == 413) {
                            error_msg += ' ' + __('File is too big.');
                        } else if (error.xhr.hasOwnProperty('responseJSON')) {
                            error_msg += ' ' + (error.xhr.responseJSON.error || '');
                        }
                    }

                    _this.errorDisplay.text(error_msg).show();
                    _this.fileDismiss.trigger('click');
                    _this.fileSelector.show();
                    _this.filePreview.show();
                },

                cancel: function () {
                    //upload cancelled
                    _this.progressDisplay.hide();
                    _this.cancelButton.hide();
                    _this.errorDisplay.hide();
                    _this.fileDismiss.trigger('click');
                    _this.fileSelector.show();
                    _this.filePreview.show();
                }

            });
        });
    });
});

/**
 * Bootstrap hash link for tabs
 */
$(function () {
    var hash = window.location.hash;
    hash && $('ul.tab-nav a[href*="' + hash + '"]').tab('show');

    $('.tab-nav li:not(.disabled) > a[href*="#"]').click(function (e) {
        var href = $(this).prop('href');
        if (href.indexOf('#') != 0 && this.pathname.indexOf(window.location.pathname) != 0) {
            window.location.replace(href);
        }

        $(this).tab('show');
        var scrollmem = $('body').scrollTop() || $('html').scrollTop();
        window.location.hash = this.hash;
        $('html,body').scrollTop(scrollmem);
    });
});

Dropzone.autoDiscover = false;
